import {autoImplement} from '@/util';

export interface ApiSupplier {
  LieferantNr: number;
  LieferantName: string;
}

interface SupplierInterface extends ApiSupplier {}

export default class Supplier extends autoImplement<SupplierInterface>() {
  static fromApi(apiSupplier: ApiSupplier): Supplier {
    return new Supplier(apiSupplier);
  }
}
